
export const DIALOG_CONFIRMATION_MOD_VERSION_TITLE = "Вы действительно хотите удалить версию мода?"

export const DIALOG_CONFIRMATION_MOD_VERSION_CONTENT = "Обратите внимание, данное действие необратимо и восстановить версию мода вы не сможете."

export const DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON = "Удалить"

export const DIALOG_CONFIRMATION_MOD_VERSION_TITLE_REJECT = "Вы действительно хотите отклонить версию мода?"

export const DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON_REJECT = "Отклонить"

export const DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON = "Отмена"
